// CommunityPhysiotherapy
import { Grid, Box, Typography } from "@mui/material";
  import ImageSlideshow from "../../components/ImageSlideShow";
  import { ZoomInRounded } from "@mui/icons-material";
  import TransitionsModal from "../../components/modal/modal";
  import ImageSlider from "../../components/ImageSlider";
  import { useState } from "react";
    import ContentLayout from "../../components/ContentLayout";

    import community_dept_img1 from "../../assets/images/facilities/infrastructure/departments/community_Dept/img-1.jpg";
    import community_dept_img2 from "../../assets/images/facilities/infrastructure/departments/community_Dept/img-2.jpg";
    import community_dept_img3 from "../../assets/images/facilities/infrastructure/departments/community_Dept/img-3.jpg";
    import community_dept_img4 from "../../assets/images/facilities/infrastructure/departments/community_Dept/img-4.jpg";
    import community_dept_img5 from "../../assets/images/facilities/infrastructure/departments/community_Dept/img-5.jpg";
    import community_dept_img6 from "../../assets/images/facilities/infrastructure/departments/community_Dept/img-6.jpg";
    import community_dept_img7 from "../../assets/images/facilities/infrastructure/departments/community_Dept/img-7.jpg";  

  type ImageType = {
    src: string;
    alt: string;
  };
  
  type DepartmentObject = {
    name: string;
    img: Array<ImageType>;
  };
  
  const DepartmentData: Array<DepartmentObject> = [
    {
      name: "Department of Community Physiotherapy",
      img: [
        { src: community_dept_img1, alt: "community_dept_img1" },
        { src: community_dept_img2, alt: "community_dept_img2" },
        { src: community_dept_img3, alt: "community_dept_img3" },
        { src: community_dept_img4, alt: "community_dept_img4" },
        { src: community_dept_img5, alt: "community_dept_img5" },
        { src: community_dept_img6, alt: "community_dept_img6" },
        { src: community_dept_img7, alt: "community_dept_img7" },
      ],
    }
  ];
  
  const CommunityPhysiotherapy = () => {
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState("");
    const [sliderImages, setSliderImages] = useState<Array<ImageType>>();

    return (
      <>
        <ContentLayout>
          <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Box sx={{ position: "relative" }} >
                  <ImageSlideshow
                    sx={{}}
                    images={DepartmentData[0]?.img as Array<ImageType>}
                    showCaption={false} showCount={false} />
                  <Box
                    sx={{
                      position: "absolute" as "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                    }}
                    onClick={() => {
                      setTitle(DepartmentData[0]?.name);
                      setSliderImages(DepartmentData[0]?.img);
                      setOpen(true);
                    } }
                  >
                    <ZoomInRounded
                      sx={{
                        color: "#fdd025",
                        zIndex: 99,
                        fontSize: "4rem",
                        "&:hover": {
                          fontSize: "6rem",
                        },
                      }} />
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography  variant="body2" textAlign="justify" mb={2} fontSize={"1rem"}>
                    The Community Physiotherapy department at PES Modern College of Physiotherapy is dedicated to preparing you for a career focused on improving the health and well-being of communities.
                    Our program emphasizes the prevention of disease, promotion of health, and rehabilitation within community settings.
                    You will learn to assess and address the physical and social factors influencing health outcomes.
                    Our curriculum covers a wide range of topics, including geriatrics, women's health, chronic disease management, and public health.
                    You will develop skills in health education, program planning, and community mobilization.
                    As a community physiotherapist, you will play a vital role in bridging the gap between healthcare and the community, empowering individuals to achieve their optimal level of function and independence. 
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="body2" textAlign="justify" mb={2} fontSize={"1rem"}>
                    Community Physiotherapy Services (CPS) offers community based rehabilitation, incorporating physical activity and education programs for adults with chronic condition.
                    Programs are designed to maximise functional ability and minimise the impact of chronic disease and related secondary complications.
                    Programs have been developed for chronic conditions that have been identified in research as benefiting from physical activity and/or specific rehabilitation programs.
                    All programs incorporate evidence-based best practice, targeting physical activity and education to empower the client to better manage their own health and maximise their functional independence.
                    CPS programs are designed for adults with a chronic disease who require physiotherapy intervention or supervision to start or return to physical activity and/or maintain their independence. 
                </Typography>

                <Typography variant="body2" textAlign="justify" mb={2} fontSize={"1rem"} fontWeight={'bold'}>
                    Geriatric Rehabilitation
                </Typography>

                <Typography variant="body2" textAlign="justify" mb={2} fontSize={"1rem"}>
                    Geriatric rehabilitation covers three areas normal aging due to disuse and deconditioning, cardiovascular problems like vascular disease and stroke, and skeletal problem including osteoporosis and osteoarthritis conditions such as knee and hip replacements.
                    Physical medicine Physicians use rehabilitation to work toward the goal of returning the patient to a pre-injury quality of life and may use physical, occupational and speech therapies. 
                </Typography>

                <Typography variant="body2" textAlign="justify" mb={2} fontSize={"1rem"} fontWeight={'bold'}>
                    The Role of Physiotherapy in Pre and Post Natal Women
                </Typography>

                <Typography variant="body2" textAlign="justify" mb={2} fontSize={"1rem"}>
                    The physical changes to women's body as related to pregnancy are multiple.<br/>
                    With respect to pregnant women, the join policy statement recommends:<br/>
                    1. Physiotherapist directed pelvic floor muscle training to prevent urinary incontinence during pregnancy and after delivery.<br/>
                    2. Physiotherapist directed core stability training to prevent and treat back and pelvic pain during and following pregnancy. 
                </Typography>



              </Grid>
          </Grid>
        </ContentLayout>

        {sliderImages && (
          <TransitionsModal
            open={open}
            setOpen={setOpen}
            title={title}
            children={<Grid item xs={12} margin={"auto"}>
              <Box sx={{ width: "75%", margin: "auto" }}>
                <ImageSlider images={sliderImages} />
              </Box>
            </Grid>} />
        )}
      </>
    );
  };
  
  export default CommunityPhysiotherapy;
  